const Outdoor = ['Scenes_01.png','Scenes_03.png','Scenes_04.png','beach01.png'];
export default Outdoor